import {Style,  RegularShape, Fill, Stroke} from 'ol/style';

import regular from './regular.js'

export const square = async (styleDef,layer,__style) => {

	var __layer = Object.assign({},layer);
	styleDef.size = 1.414 * styleDef.size;
	__layer.point = 4;
	__layer.angle = 45 + (__layer.angle || 0);

	__layer.anchor = __layer.anchor || [0.5,0.5]
	__layer.anchor = [
		0.5 + (__layer.anchor[0]-0.5)*1.414,
		0.5 + (__layer.anchor[1]-0.5)*1.414,
	]
	return await regular(styleDef, __layer, __style);
};

export  default square;